import { render } from "./MyStep.vue?vue&type=template&id=5a0aa331&scoped=true"
import script from "./MyStep.vue?vue&type=script&lang=js"
export * from "./MyStep.vue?vue&type=script&lang=js"

import "./MyStep.vue?vue&type=style&index=0&id=5a0aa331&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0aa331"]])

export default __exports__